export default __webpack_public_path__ + "src/images/home/screenshot-13d9da5b91fef5e90b40c8abb725b8ca.png";